import React from 'react'
import { Link } from 'react-router-dom'
import './style.scss'
/* eslint-disable camelcase */
export const ArtistCard = (props) => {
  const {
    nombre_artista,
    foto_artista,
    aid
  } = props

  return (
    // Aún no hay ruta de artistas
    <Link to={`/artista/${aid}`}>
        <div className="text-center">
            <img src={foto_artista} className="profile-card" />
            <p className="pt-3">{nombre_artista}</p>
        </div>
    </Link>
  )
}
